import { LoadingSkeleton } from '@bloomfieldrobotics/canopy';
import { Divider, Stack } from '@mui/material';

export const ChartsLoadingOverlay = () => {
  const bars = [100, 95, 88, 75, 67, 62];

  return (
    <Stack spacing={6} sx={{ padding: 4, paddingLeft: 1, paddingRight: 1 }}>
      <Stack spacing={2} direction='row'>
        <LoadingSkeleton loading sx={{ height: '16px', width: '10px' }} />
        <LoadingSkeleton loading sx={{ height: '16px', width: '100px' }} />
      </Stack>
      <Stack spacing={2} direction='row' sx={{ padding: '0 1rem' }}>
        <Stack spacing={3}>
          {bars.map((index) => (
            <LoadingSkeleton
              key={index}
              sx={{ width: '34px', height: '16px' }}
              loading
            />
          ))}
        </Stack>
        <Stack spacing={3} sx={{ width: '100%' }}>
          {bars.map((val) => (
            <LoadingSkeleton
              key={val}
              sx={{ width: `${val}%`, height: '16px', borderRadius: 0 }}
              loading
            />
          ))}
        </Stack>
      </Stack>
      <Divider />
      <Stack spacing={2} direction='row'>
        <LoadingSkeleton loading sx={{ height: '16px', width: '10px' }} />
        <LoadingSkeleton loading sx={{ height: '16px', width: '100px' }} />
      </Stack>
      <Divider />
      <Stack spacing={2} direction='row'>
        <LoadingSkeleton loading sx={{ height: '16px', width: '10px' }} />
        <LoadingSkeleton loading sx={{ height: '16px', width: '100px' }} />
      </Stack>
    </Stack>
  );
};
